import { render, staticRenderFns } from "./ModalAddMember.vue?vue&type=template&id=e96ef0c8&scoped=true"
import script from "./ModalAddMember.vue?vue&type=script&lang=js"
export * from "./ModalAddMember.vue?vue&type=script&lang=js"
import style0 from "./ModalAddMember.vue?vue&type=style&index=0&id=e96ef0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96ef0c8",
  null
  
)

export default component.exports